import {
  DIFFICULTY_MIN_GAP,
  DIFFICULTY_RAMP_SCORES,
  DIFFICULTY_RAMP_SECONDS,
  NIGHT_SECONDS,
  NIGHT_THRESHOLD,
  PIPE_GAP,
  SCROLL_SPEED,
} from "../../config";
import { clamp } from "../../utils/math";

export interface DifficultyParams {
  scrollSpeed: number;
  pipeGap: number;
}

function rampAt(t: number): DifficultyParams {
  const c = clamp(t, 0, 1);
  // The scroll speed is constant — the game never speeds up. Only the pipe gap
  // ramps: because `c` is continuous (score / DIFFICULTY_RAMP_SCORES), each pipe
  // nudges the gap a tiny fixed step narrower until it tops out at
  // DIFFICULTY_MIN_GAP once the player passes DIFFICULTY_RAMP_SCORES.
  return {
    scrollSpeed: SCROLL_SPEED,
    pipeGap: PIPE_GAP + (DIFFICULTY_MIN_GAP - PIPE_GAP) * c,
  };
}

export function difficultyFor(score: number): DifficultyParams {
  return rampAt(score / DIFFICULTY_RAMP_SCORES);
}

/** Time-driven ramp used by ghost races so both clients see identical pipes. */
export function difficultyForTime(elapsedSeconds: number): DifficultyParams {
  return rampAt(elapsedSeconds / DIFFICULTY_RAMP_SECONDS);
}

// Day/night phase (visual + music only; the scroll speed is the same in both).
// Solo + battle runs flip by score (every NIGHT_THRESHOLD pipes); ghost races flip
// by elapsed time (every NIGHT_SECONDS) so both clients agree.
export function isNightForScore(score: number): boolean {
  return Math.floor(score / NIGHT_THRESHOLD) % 2 === 1;
}
export function isNightForTime(elapsedSeconds: number): boolean {
  return Math.floor(elapsedSeconds / NIGHT_SECONDS) % 2 === 1;
}
